import type { FC } from "react";
import { useOutletContext } from "react-router-dom";
import { DocumentListPage } from "web_myplann/Portfolio/Pages/Documents/DocumentListPage";
import type { PortfolioTabContext } from "web_myplann/Portfolio/Pages/PortfolioTabsLayout";

export const DocumentsListTab: FC = () => {
	const { setIsLoading } = useOutletContext<PortfolioTabContext>();
	return <DocumentListPage setIsLoading={setIsLoading} />;
};
